import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="120px" viewBox="0 0 387.225 168.234">
  <defs>
    <linearGradient id="pc-module-sex-distribution-5-linear-gradient" x1="0.5" y1="0.414" x2="0.5" y2="1.2" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="#fff"/>
      <stop offset="1" stop-color="var(--theme-color-1)"/>
    </linearGradient>
    <linearGradient id="pc-module-sex-distribution-5-linear-gradient-10" x1="0.5" y1="0.414" x2="0.5" y2="1.2" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="#fff"/>
      <stop offset="1" stop-color="var(--theme-color-2)"/>
    </linearGradient>
  </defs>
  <g id="xingbie5" transform="translate(-67.888 -117.266)">
    <path id="路径_5332" data-name="路径 5332" d="M-10248.965,5589.049l-92.151,43.028,92.151,39.481,91.712-39.481Z" transform="translate(10612.365 -5432.268)" fill="url(#pc-module-sex-distribution-5-linear-gradient-10)"/>
    <path id="路径_5333" data-name="路径 5333" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10639.12 -5420.244)" fill="#fff"/>
    <path id="路径_5334" data-name="路径 5334" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10639.491 -5438.594)" fill="var(--theme-color-2)" opacity="0.6"/>
    <path id="路径_5335" data-name="路径 5335" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10639.491 -5453.242)" fill="#fff" stroke="var(--theme-color-2)" stroke-width="1"/>
    <g id="nan_5">
      <path id="路径_5331" data-name="路径 5331" d="M-10248.965,5589.049l-92.151,43.028,92.151,39.481,91.712-39.481Z" transform="translate(10409.004 -5432.268)" fill="url(#pc-module-sex-distribution-5-linear-gradient)"/>
      <path id="路径_5330" data-name="路径 5330" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10435.759 -5420.244)" fill="#fff"/>
      <path id="路径_5329" data-name="路径 5329" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10436.131 -5438.594)" fill="var(--theme-color-1)"/>
      <path id="路径_5328" data-name="路径 5328" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10436.131 -5453.242)" fill="#fff" stroke="var(--theme-color-1)" stroke-width="1"/>
      <path id="路径_5327" data-name="路径 5327" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10436.131 -5471.783)" fill="var(--theme-color-1)"/>
    </g>
    <path id="路径_5336" data-name="路径 5336" d="M-10275.819,5589.049l-65.3,30.488,65.3,27.975,64.984-27.975Z" transform="translate(10639.491 -5471.783)" fill="var(--theme-color-2)" />
    <text id="_10人" data-name="10人" transform="translate(132.699 154.461)" fill="#fff" font-size="26" font-weight="600"><tspan x="0" y="0">10人</tspan></text>
    <text id="_11人" data-name="11人" transform="translate(335.016 154.461)" fill="#fff" font-size="26" font-weight="600"><tspan x="0" y="0">11人</tspan></text>
    <text id="男性" transform="translate(138.33 280.5)" fill="#222" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">男性</tspan></text>
    <text id="女性" transform="translate(344.191 280.5)" fill="#222" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">女性</tspan></text>
  </g>
</svg>
`;

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-sex-distribution-5',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "svg-block",
    innerHTML: svg
  }))
}
}

})